import { render, staticRenderFns } from "./deanInputSelectMultiDragDrop.vue?vue&type=template&id=238198c2&scoped=true"
import script from "./deanInputSelectMultiDragDrop.vue?vue&type=script&lang=ts"
export * from "./deanInputSelectMultiDragDrop.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSelectMultiDragDrop.vue?vue&type=style&index=0&id=238198c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238198c2",
  null
  
)

export default component.exports